// Commercial intent only. Never stores credentials or treats a URL as permission.
const key = "fornecedor_registration_plan";
export function captureRegistrationIntent(search: string) {
  const query = new URLSearchParams(search), plan = query.get("plan"), billing = query.get("billing");
  if (plan && /^[a-z0-9_\-]{1,100}$/.test(plan) && (!billing || ["monthly", "yearly"].includes(billing))) {
    localStorage.setItem(key, JSON.stringify({ requested_plan: plan, requested_billing: billing || "monthly" }));
  }
}
export function registrationIntent(): { requested_plan?: string; requested_billing?: "monthly" | "yearly" } {
  if (typeof window === "undefined") return {};
  try {
    const data = JSON.parse(localStorage.getItem(key) || "{}");
    return typeof data.requested_plan === "string" && /^[a-z0-9_\-]{1,100}$/.test(data.requested_plan) && ["monthly", "yearly"].includes(data.requested_billing) ? data : {};
  } catch { return {}; }
}
export function selectedPlanPath() {
  const intent = registrationIntent();
  if (!intent.requested_plan) return "/empresa/inicio";
  return intent.requested_plan.startsWith("food_")
    ? `/empresa/food/contratar?plan=${encodeURIComponent(intent.requested_plan)}`
    : `/empresa/upgrade/${encodeURIComponent(intent.requested_plan)}?billing=${intent.requested_billing}`;
}
export function clearRegistrationIntent() { localStorage.removeItem(key); }
